import { redirect } from '../actions/redirectActions';
import { useHistory } from 'react-router-dom';

const redirectMiddleware = () => (store) => (next) => (action) => {
	// console.log('dispatching', action);

	switch (action.type) {
		case 'REDIRECT':
			// console.log("redirect middleware");
			break; // very important
	}

	return next(action);
};

export default redirectMiddleware;
